import { styled } from "@mui/material";

const PREFIX = "cq-results";
export const classes = {
  root: `${PREFIX}-root`,
  resultButtons: `${PREFIX}-resultButtons`,
  previewContainer: `${PREFIX}-previewContainer`,
  resultContainer: `${PREFIX}-resultContainer`,
  container: `${PREFIX}-container`,
  animalScoreContainer: `${PREFIX}-animalScoreContainer`,
  animalScore: `${PREFIX}-animalScore`,
  padding: `${PREFIX}-padding`,
  previewText: `${PREFIX}-previewText`,
  previewAnimal: `${PREFIX}-previewAnimal`,
  image: `${PREFIX}-image`,
  smallImage: `${PREFIX}-smallImage`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  boldText: `${PREFIX}-boldText`,
  strengths: `${PREFIX}-strengths`,
  graphContainer: `${PREFIX}-graphContainer`,
  occupationContainer: `${PREFIX}-occupationContainer`,
  occupations: `${PREFIX}-occupations`,
  careerAreaContainer: `${PREFIX}-careerAreaContainer`,
  startOverButton: `${PREFIX}-startOverButton`,
  link: `${PREFIX}-link`,
};

export const CustomGrid = styled("div")(({ theme }) => ({
  [`&.${classes.root}`]: {
    height: "100%",
  },
  [`& .${classes.resultButtons}`]: {
    padding: "8px 38px 0px",
    "@media (max-width: 937px)": {
      padding: "5px 28px 0px",
    },
    "@media (max-width: 900px)": {
      padding: "5px 18px 0px",
    },
    "@media (max-width: 750px)": {
      padding: "5px",
    },
  },
  [`& .${classes.previewContainer}`]: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    color: theme.palette.white.main,
    fontSize: "32px",
    padding: "8px",
  },
  [`& .${classes.resultContainer}`]: {
    display: "flex",
    flexDirection: "row",
    padding: "10px 20px 20px",
    "@media (max-width: 900px)": {
      padding: "10px 0px 20px",
    },
  },
  [`& .${classes.container}`]: {
    marginBottom: "20px",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: "4px",
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
    backgroundColor: theme.palette.background.level1,
    "@media (max-width: 900px)": {
      marginBottom: "15px",
    },
  },
  [`& .${classes.animalScoreContainer}`]: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 30px",
  },
  [`& .${classes.animalScore}`]: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    alignItems: "center",
  },
  [`& .${classes.padding}`]: {
    padding: "20px 15px 0px",
    "@media (max-width: 900px)": {
      padding: "10px 5px",
    },
  },
  [`& .${classes.previewText}`]: {
    padding: "30px",
    paddingRight: "0px",
    maxWidth: "600px",
    "@media (min-width: 1200px)": {
      maxWidth: "850px",
    },
    "@media (max-width: 937px)": {
      padding: "20px",
      maxWidth: "400px",
    },
    "@media (max-width: 900px)": {
      padding: "20px 10px",
    },
    "@media (max-width: 750px)": {
      maxWidth: "none",
      padding: "10px 0px",
    },
  },
  [`& .${classes.previewAnimal}`]: {
    maxWidth: "400px",
    alignSelf: "center",
    padding: "30px",
    paddingLeft: "10px",
    "@media (max-width: 937px)": {
      padding: "20px",
    },
    "@media (max-width: 900px)": {
      padding: "20px 10px",
    },
    "@media (max-width: 750px)": {
      maxWidth: "none",
      padding: "10px 0px",
    },
  },
  [`& .${classes.image}`]: {
    width: "100%",
    objectFit: "cover",
  },
  [`& .${classes.smallImage}`]: {
    height: "100px",
    margin: "10px 0px",
    objectFit: "cover",
  },
  [`& .${classes.buttonContainer}`]: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "@media (max-width: 1200px)": {
      marginTop: "30px",
    },
  },
  [`& .${classes.boldText}`]: {
    fontWeight: 500,
  },
  [`& .${classes.strengths}`]: {
    display: "flex",
    flexDirection: "row",
  },
  [`& .${classes.graphContainer}`]: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "@media (max-width: 600px)": {
      padding: "20px 0px",
    },
  },
  [`& .${classes.occupationContainer}`]: {
    display: "flex",
    flexDirection: "row",
    padding: "20px",
    marginLeft: "20px",
    "@media (max-width: 1200px)": {
      flexDirection: "column",
    },
    "@media (max-width: 900px)": {
      marginLeft: 0,
    },
  },
  [`& .${classes.occupations}`]: {
    margin: "25px 0px 15px",
    "@media (max-width: 1200px)": {
      marginBottom: "0px",
    },
  },
  [`& .${classes.careerAreaContainer}`]: {
    display: "flex",
    flexDirection: "column",
    padding: "20px",
    marginLeft: "20px",
    "@media (max-width: 900px)": {
      marginLeft: 0,
    },
  },
  [`& .${classes.startOverButton}`]: {
    position: "fixed",
    bottom: 0,
    right: "20px",
    borderRadius: "8px 8px 0 0",
    height: "36px",
  },
  [`& .${classes.link}`]: {
    fontWeight: 500,
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));
